import { TypeGenerator } from '../utils/type';
import { IArgumentType } from '../functions/utils';
import { hasNotDigitArgs } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';


// 取余，与 / 相同
export function MOD(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  if (args.length !== 2) {
    throw new InferenceError('function-argument-error', `${functionName} 函数只接受两个参数`, token.position);
  }

  if (hasNotDigitArgs(args)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的参数不能为非数字类型`, token.position);
  }

  return TypeGenerator.Number();
}
